import {ProductSummary} from "@/product/interfaces/ProductSummary";
import Dosage from "@/dosage/interfaces/Dosage";

export interface ConsumerProduct {
    id: number;
    product: ProductWithLatestDosage;
    source_type: SourceType | null;
    created_at: string;
    observance?: { score: number; reasons: string[]; title: string; color: string } | null;
    issues: ConsumerProductIssue[];
    alerts: ConsumerProductAlert[];
}

export interface ConsumerProductIssue {
    id: number;
    type: 'galenic' | 'side_effect';
    comment: string | null;
}

export interface ConsumerProductAlert {
    id: number;
    content: string;
}

export enum SourceType {
    PRESCRIPTION = "prescription",
    SELF_MEDICATION = "self_medication"
}

export interface ProductWithLatestDosage extends ProductSummary {
    latest_dosage?: Dosage;
}
